/**
 * CustomGrid - Index export file
 * Exports the CustomGrid and EditDialog components for use across the application
 */

import CustomGrid from './CustomGrid';
import { applyFilter, getOperatorsForType } from './CustomGrid';
import EditDialog from './EditDialog';

export default CustomGrid;
export { CustomGrid, EditDialog, applyFilter, getOperatorsForType };
